import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { DEFAULT_OTHER_NODE } from "../shared/other-node";
import { SelfServeNode } from "../types";

export const getDefaultOtherNodeOrUndefined = (
  nodesInLevelThatWillBeRendered: SelfServeNode[],
  strictLocalize: StrictLocalizeFunction
): SelfServeNode | undefined => {
  const otherNode = DEFAULT_OTHER_NODE(strictLocalize);
  const shouldRenderDefaultOtherNode = nodesInLevelThatWillBeRendered.every(
    (node) => node.label !== otherNode.label
  );
  return shouldRenderDefaultOtherNode ? otherNode : undefined;
};
